import { createContext, useContext, useState, useEffect } from "react";
const ThemeContext = createContext({
	theme: "light",
	toggleTheme: () => null,
});

export const useTheme = () => {
	const context = useContext(ThemeContext);
	if (!context) {
		throw new Error("useTheme must be used within a ThemeProvider");
	}
	return context;
};

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState(() => {
		const savedTheme = localStorage.getItem("theme");
		if (
			!savedTheme &&
			window.matchMedia("(prefers-color-scheme: dark)").matches
		) {
			return "dark";
		}
		return savedTheme || "light";
	});

	useEffect(() => {
		localStorage.setItem("theme", theme);
		if (theme === "light") {
			document.body.setAttribute("data-theme", "light");
		} else {
			document.body.setAttribute("data-theme", "dark");
		}
	}, [theme]);

	const toggleTheme = () => {
		setTheme((prev) => (prev === "light" ? "dark" : "light"));
	};

	return (
		<ThemeContext.Provider value={{ theme, toggleTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};
